import axios from "axios";

const BASE_URL = "https://berkah.bondowosokab.go.id:5500";
const API_KEY = "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Bondowoso-Berkah": API_KEY,
  },
});

function ambilData(res) {
  return res?.data?.response?.data ?? null;
}

async function ambil(path) {
  const res = await api.get(`/api/android/init/${path}`);
  return ambilData(res);
}

export const getHeader = () => ambil("header");
export const getCategories = () => ambil("categories");
export const getSubCategories = () => ambil("sub-categories");
export const getTenants = () => ambil("tenants");
export const getTenantUnits = () => ambil("tenant-units");
export const getRekapBencana = () => ambil("rekap-bencana");
export const getTitikKumpulBencana = () => ambil("titik-kumpul-bencana");
export const getPengalihanJalan = () => ambil("pengalihan-jalan");
export const getHargaBahan = () => ambil("harga-bahan");
export const getHargaBahanBaru = () => ambil("harga-bahan-baru");
export const getInfoBencana = () => ambil("info-bencana");
export const getKecamatan = () => ambil("kecamatan");
export const getPotensiDesa = () => ambil("potensi-desa");
export const getFlyer = () => ambil("flyer");
export const getDesa = () => ambil("desa");
export const getLayananPublik = () => ambil("layanan-publik-new");
export const getOpd = () => ambil("opd");
export const getKabar = () => ambil("kabar");
export const getKegiatan = () => ambil("kegiatan");
export const getMomen = () => ambil("momen");
export const getPotensiSpasial = () => ambil("potensi-spasial");
export const getPertanianKomoditas = () => ambil("pertanian-komoditas");

export async function getBeberapaBagian(daftarFungsi) {
  const hasil = await Promise.all(daftarFungsi.map((fn) => fn()));
  return hasil;
}

export default api;
